module.exports = __webpack_public_path__ + "static/img/4.3c04e1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/4.jpg
// module id = cmSw
// module chunks = 21